import axios from "axios";
import { UserJiraProfileDto } from "./models/UserJiraProfileDto";

export const getUserJiraProfile = async (): Promise<UserJiraProfileDto> => {
  const { data } = await axios.get<UserJiraProfileDto>(
    `${window.configuration.apiUrl}api/Users/me/jira-profile`
  );
  return data;
};

export const updateAtlassianDisplayName = async (displayName: string): Promise<void> => {
  await axios.patch(`${window.configuration.apiUrl}api/Users/me/jira-profile`, {
    displayName,
  });
};
